
























































































import 'reflect-metadata'
import { Component, Vue } from 'vue-property-decorator'


import DataTableInspectionPlan from "@/components/report/datatable/DataTableInspectionPlan.vue"
import DropDownProject from "@/components/common/combobox/DropDownProject.vue"
import DatePickerFromTo from "@/components/common/date-picker/DatePickerFromTo.vue"
import Notification from "@/components/common/notification/Notification.vue"
import BreadcrumbsPath from "@/components/common/breadcrumbs/BreadcrumbsPath.vue"
import { ReportApi, ProjectApi, AuthenticateApi, PlanningTransferApi } from '@/api'
import { ExportExcel } from '@/resource/report/InspectionPlanExcel'
import { namespace } from 'vuex-class'

const Auth = namespace('authentication')

@Component({
    components: {
        'common-combobox-dropdownproject': DropDownProject,
        DatePickerFromTo,
        DataTableInspectionPlan,
        Notification,
        BreadcrumbsPath
    }
})
export default class InspectionPlan extends Vue { 
    breadcrumbs = [
        { text: 'Report' },
        { text: 'Hierarchy' }
    ]
    
    @Auth.State('auth') auth!: any

    panel = 0
    projectLists = [] as any
    loading = false
    jsonData = {
        projectId: 0 as number,
        projectName: "" as string,
        dateFrom: "" as string,
        dateTo: "" as string,
    } as any
    tableShow = false

    created () {
		this.StartUp()
	}

    async StartUp () {
        this.loading = true

        const getUserInfo = await AuthenticateApi.GetUserInfo()
            const hasMatchingPermission = getUserInfo?.permission.filter((filter) => filter.profileCode === "TFP-06" );

            if (hasMatchingPermission && hasMatchingPermission?.length <= 0) {
                localStorage.clear()
                window.location.reload()
            }

        this.projectLists = await ProjectApi.GetProjectLists()
        this.loading = false
    }

    async btnSearch () {
        this.loading = true

        if (this.jsonData.projectId === 0 || this.jsonData.projectId === "") {
            this.openNotification('กรุณาเลือกโครงการ', 'warning') 
            this.loading = false
            return
        }

        if (this.jsonData.dateFrom === "" || this.jsonData.dateFrom === "") {
            this.openNotification('กรุณาเลือกวันที่ CR นัดตรวจ', 'warning') 
            this.loading = false
            return
        }

        try {

            const refDataTableInspectionPlan = this.$refs.refDataTableInspectionPlan as DataTableInspectionPlan

            const getReportInspectionPlanning = await ReportApi.GetReportInspectionPlanning({
                projectId: parseInt(this.jsonData.projectId),
                dateFrom: this.jsonData.dateFrom,
                dateTo: this.jsonData.dateTo,
            })

            const projectNames = this.projectLists
                .filter((project:any) => this.jsonData.projectId.includes(project.id))
                .map((project:any) => project.name);
            this.jsonData.projectName = projectNames

            const logModel = {
                application_name: "Transfer_Planning",
                feature: "btnSearch Data Found : " + getReportInspectionPlanning.length.toString() + " Records",
                page: "Planning Report",
                json_data: JSON.stringify(this.jsonData),
                created_by: this.auth.username,
                };

            PlanningTransferApi.addLog(logModel)

            if (getReportInspectionPlanning.length <= 0) {
                this.openNotification('ไม่พบข้อมูลที่ค้นหา', 'warning') 
                refDataTableInspectionPlan.clearDataTable()
                this.tableShow = false
                this.loading = false
                return
            }

            refDataTableInspectionPlan.setTableData(getReportInspectionPlanning)
            this.tableShow = true
            this.loading = false
            return
        } catch (error) {
            this.openNotification('ไม่สามารถค้นหาข้อมูลได้ กรุณาลองใหม่', 'warning') 
            this.loading = false
        }
    }  

    async btnExportExcel () {
        this.loading = true

        if (this.jsonData.projectId === 0 || this.jsonData.projectId === "") {
            this.openNotification('กรุณาเลือกโครงการ', 'warning') 
            this.loading = false
            return
        }

        if (this.jsonData.dateFrom === "" || this.jsonData.dateFrom === "") {
            this.openNotification('กรุณาเลือกวันที่ CR นัดตรวจ', 'warning') 
            this.loading = false
            return
        }

        const projectNames = this.projectLists
                .filter((project:any) => this.jsonData.projectId.includes(project.id))
                .map((project:any) => project.name);
            this.jsonData.projectName = projectNames

        const logModel = {
                application_name: "Transfer_Planning",
                feature: "btnExportExcel",
                page: "Planning Report",
                json_data: JSON.stringify(this.jsonData),
                created_by: this.auth.username,
                };

            PlanningTransferApi.addLog(logModel)

        try {

            let getReportInspectionPlanning = await ReportApi.GetReportInspectionPlanning({
                projectId: parseInt(this.jsonData.projectId),
                dateFrom: this.jsonData.dateFrom,
                dateTo: this.jsonData.dateTo,
            })

            if (getReportInspectionPlanning.length <= 0) {
                this.openNotification('ไม่พบข้อมูลที่ค้นหา', 'warning') 
                this.tableShow = false
                this.loading = false
                return
            }           
            await ExportExcel(getReportInspectionPlanning)
            this.openNotification('Export Excel สำเร็จ', 'success') 
            this.loading = false
            return
        } catch {
            this.openNotification('ไม่สามารถค้นหาข้อมูลได้ กรุณาลองใหม่', 'warning') 
            this.loading = false
        }
    }

    openNotification (text: string, status: string) {
        const child = this.$refs.refNotifcation as any
        child.openNotification(text, status)
    }

    changeState (key: string, value: string) {
        this.jsonData[key] = value
    }

}
